import { createSlice } from "@reduxjs/toolkit";

export interface BranchState {
  isAddBranch: boolean;
}

const initialState: BranchState = {
  isAddBranch: false,
};

const branchSlice = createSlice({
  name: "branch-functional",
  initialState,
  reducers: {
    setIsAddBranch(state, action) {
      state.isAddBranch = action.payload;
    },
  },
});

export const { setIsAddBranch } = branchSlice.actions;

export default branchSlice.reducer;
